<div
  class="filter-button-wrapper"
  [ngClass]="{'disabled': disabled}"
  (click)="doAction()"
>
  <p class="label">{{ label }}</p>
  <p class="value">{{ valueLabel | translate }}</p>
</div>
